<template>
    <ValidationProvider v-slot="{ errors }" name="Broker" rules="required">
        <AdvancedDropdown v-model="modelValue" v-bind="$attrs"
         :options="brokerOptions"
         :disabled="false"
         :can-add-new="false"
         label="" 
         size="sm">
            <!-- <template v-slot:label> Broker <span class="text-danger">*</span> </template> -->

            <template v-slot:button-content>
                <template v-if="!!selectedOption">{{ selectedOption.text }}</template>
                <template v-else>Select</template>
            </template>

        </AdvancedDropdown>

        <div v-if="!!errors.length" class="invalid-feedback d-block">
            {{ errors[0] }}
        </div>
    </ValidationProvider>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'
import { ValidationProvider } from 'vee-validate'
import  { LincolnRLSGroupsService }  from '@services'


import {
    useCurrentUser
} from '@composables'

import { BaseIcon } from '@components/base'
import { AdvancedDropdown } from '@components/advanced'

export default {
    name: 'CashCallFormBroker',
    components: {
        ValidationProvider,

        BaseIcon,

        AdvancedDropdown


    },
    props: {
        value: {
            type: Array,
            default: () => []
        }
    },
    data() {
    return {
      brokerOptions: [],
      brokersRaw: [],
      loading: false, 
    }
  },
  computed: {
    modelValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
    selectedOption() {
      const brokerName = this.value[0]
      console.log('Selected Broker:' + brokerName)
      if (!brokerName) 
      {
        this.$emit('update:selectedBroker', brokerName)
        return null
      }
      const broker = this.brokersRaw.find(
        b => b.broker === brokerName
        )

      const brokerId = broker ? broker.id : 0

        // Emit filtered broker to parent component
        this.$emit('update:selectedBroker', brokerName)
        this.$emit('update:selectedBrokerId', brokerId)

        return this.brokerOptions.find(opt => opt.text === brokerName) || null
    }
  },
    methods: {
        async getBrokers() {
            const RLS = 'Broker'
            console.log('Broker Values:')
            const response  = await LincolnRLSGroupsService.list(RLS)
            if(response.status == 200) {
            const brokerList = response.data.data
            this.brokersRaw = response.data.data
            console.log(brokerList)
            this.brokerOptions = brokerList.map(item => ({
            text: item.broker,
            value: item.broker
            }))            
            }
        }
    },
mounted() {
    this.getBrokers()
}    
}
</script>

<style scoped>
.advanced-dropdown>>>.dropdown-toggle {
    max-width: 214px;
}

.advanced-dropdown>>>.dropdown-menu {
    /* Shorter than the shared 320px: these four sit low in the Claim Details
       summary box, so the menu opens upward and runs off the top of the modal.
       ~5 rows plus the search bar. */
    max-height: 210px;
}

.advanced-dropdown>>>.dropdown-menu .list-group-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.advanced-dropdown>>>.dropdown-menu .list-group-item.disabled {
    color: #fff;
    background-color: #1c4a50;
    pointer-events: initial;
}
</style>